// Advance only forward when a card leaves the list
export const nextOpenCardId = (
  cardIds: readonly string[],
  leavingId: string
): string | undefined => {
  const index = cardIds.indexOf(leavingId);
  if (index < 0) return undefined;
  return cardIds[index + 1];
};

// The card ↑ or ↓ opens: the first card when none is open, and none past either end
export const steppedOpenCardId = (
  cardIds: readonly string[],
  openId: string | undefined,
  step: -1 | 1
): string | undefined => {
  const index = openId === undefined ? -1 : cardIds.indexOf(openId);
  return index < 0 ? cardIds[0] : cardIds[index + step];
};
